import { Injectable } from '@angular/core';
import { Action, Selector, State, StateContext } from '@ngxs/store';
import { DeleteSectionsAction, GetAllSectionsAction } from './sections.actions';
import { HttpService } from '../../core/services/http/http.service';
import { ITramo } from '../../core/interfaces/exit-points.interface';
import { EnovaAlertsComponent } from '../../core/utils/enova-alerts/enova-alerts.component';
import { MatDialog } from '@angular/material/dialog';

export interface SectionsStateModel {
  sections: ITramo[];
}

@State<SectionsStateModel>({
  name: 'sections',
  defaults: {
    sections: [],
  },
})
@Injectable()
export class SectionsState {
  @Selector() static GetAllData(state: SectionsStateModel): ITramo[] {
    return state?.sections ? state?.sections : [];
  }

  constructor(
    private httpService: HttpService,
    private dialog: MatDialog
  ) {}

  @Action(GetAllSectionsAction)
  async GetAllSectionsAction(ctx: StateContext<SectionsStateModel>) {
    try {
      const resp = await this.httpService.getSections();
      if (resp && resp.length) {
        ctx.patchState({
          sections: resp,
        });
      }
    } catch (error) {
      console.error(error);
    }
  }

  // @Action(AddSectionsAction)
  // async AddSectionsAction(
  //   ctx: StateContext<SectionsState>,
  //   { payload }: AddSectionsAction
  // ) {
  //   ctx.dispatch(new LoadingShowAction());
  //   return this.httpService
  //     .postSection(payload)
  //     .then(() => {
  //       this.dialog.open(EnovaAlertsComponent, {
  //         width: 'auto',
  //         data: {
  //           type: 'success',
  //           text: 'El tramo se ha creado de forma exitosa!',
  //           hiddeCancelBtn: true,
  //         },
  //       });
  //       ctx.dispatch(new GetAllSectionsAction());
  //     })
  //     .catch((err) => {
  //       console.log(err);

  //       this.dialog.open(EnovaAlertsComponent, {
  //         width: 'auto',
  //         data: {
  //           type: 'error',
  //           hiddeCancelBtn: true,
  //         },
  //       });
  //     })
  //     .finally(() => {
  //       ctx.dispatch(new LoadingHiddeAction());
  //     });
  // }

  // @Action(UpdatedSectionsAction)
  // async UpdatedSectionsAction(
  //   ctx: StateContext<SectionsState>,
  //   { payload }: UpdatedSectionsAction
  // ) {
  //   ctx.dispatch(new LoadingShowAction());
  //   return this.httpService
  //     .updateSection(payload)
  //     .then(() => {
  //       this.dialog.open(EnovaAlertsComponent, {
  //         width: 'auto',
  //         data: {
  //           type: 'success',
  //           text: 'El tramo se ha actualizado de forma exitosa!',
  //           hiddeCancelBtn: true,
  //         },
  //       });
  //       ctx.dispatch(new GetAllSectionsAction());
  //     })
  //     .catch(() => {
  //       this.dialog.open(EnovaAlertsComponent, {
  //         width: 'auto',
  //         data: {
  //           type: 'error',
  //           hiddeCancelBtn: true,
  //         },
  //       });
  //     })
  //     .finally(() => {
  //       ctx.dispatch(new LoadingHiddeAction());
  //     });
  // }

  @Action(DeleteSectionsAction)
  async DeleteSectionsAction(
    ctx: StateContext<SectionsState>,
    { payload }: DeleteSectionsAction
  ) {
    return this.httpService
      .deleteSection(payload)
      .then(() => {
        this.dialog.open(EnovaAlertsComponent, {
          width: 'auto',
          data: {
            type: 'success',
            text: 'El punto de salida se ha eliminado de forma exitosa!',
            hiddeCancelBtn: true,
          },
        });
        ctx.dispatch(new GetAllSectionsAction());
      })
      .catch(() => {
        this.dialog.open(EnovaAlertsComponent, {
          width: 'auto',
          data: {
            type: 'error',
            hiddeCancelBtn: true,
          },
        });
      });
  }
}
